// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1150":"94f552a2","3753":"0e4a0c32"}[chunkId] + ".chunk.css";
};